import {} from '../services/fetch_api';

import React, { useState, useEffect, useCallback } from 'react';
import '../css/sg-platform.css';
import '../css/sg-profile.css';
import placeholderImage from '../assets/placeholder.jpg';

import {
  updateUserData,
  saveExplorationData,
  fetchExplorationById, // Import the new function to fetch single exploration
  saveCultureData,
  getTipoCulturaChoices,
  getTipoProducaoChoices,
  getTipoSistemaRegaChoices,
  getClasseTexturalChoices,
  getCaracteristicasAnoChoices,
  fetchExploracoes, // Import the function to fetch exploracoes
  uploadProfilePhoto, // Import the function to upload profile photo
  getProfilePhoto, // Import the function to get profile photo
  uploadPdfFile,
  uploadWaterMapFileForCulture, // Import the function to upload water map PDF for specific culture
  uploadOtherDocsFileForCulture, // Import the function to upload other docs PDF for specific culture
  getIFAP_PdfFile, // Import the function to get PDF file
  getWaterMapPdfFile, // Import the function to get water map PDF file
  getOtherDocsPdfFile, // Import the function to get other docs PDF file
  getEstadosChoices,
  generatePdfForCulture, // Import the function to generate PDF for culture
  fetchMapaSectoresFileName,
  fetchOtherDocsFileName,
} from '../services/fetch_api';
import { useAuth } from '../services/authContext';

const Profile = () => {
  const { user, token, isAuthenticated, refreshUserData } = useAuth(); // Get the user info, token, and refreshUserData function

  // --------------- Lógica do Perfil --------------- //
  const [profilePhoto, setProfilePhoto] = useState(user?.profile_photo || '');
  const [shouldFetchProfilePhoto, setShouldFetchProfilePhoto] = useState(false);
  const [name, setName] = useState(user?.first_name || '');
  const [surname, setSurname] = useState(user?.last_name || '');
  const [personalPhone, setPersonalPhone] = useState(user?.user_telefone || '');
  const [email, setEmail] = useState(user?.email || '');
  const [companyName, setCompanyName] = useState(user?.organizacao_nome || '');
  const [companyAddress, setCompanyAddress] = useState(
    user?.organizacao_morada || ''
  );
  const [companyPhone, setCompanyPhone] = useState(
    user?.organizacao_telefone || ''
  );
  const [companyEmail, setCompanyEmail] = useState(
    user?.organizacao_email || ''
  );
  const [ifapNumber, setIfapNumber] = useState(user?.ifap_number || '');
  // PDF file names for different uploads
  const [pdfFileName, setPdfFileName] = useState('Nenhum ficheiro carregado'); // For exploration certification
  const [mapaSectoresFileName, setMapaSectoresFileName] = useState(
    'Nenhum ficheiro carregado'
  ); // For water map
  const [otherDocsFileName, setOtherDocsFileName] = useState(
    'Nenhum ficheiro carregado'
  ); // For other docs

  // PDF files for culture uploads
  const [mapaSectoresFile, setMapaSectoresFile] = useState(null);
  const [otherDocsFile, setOtherDocsFile] = useState(null);

  // Função para atualizar nomes de ficheiros de cultura ao editar/abrir cultura
  const updateCultureFileNames = async (cultureId) => {
    if (!cultureId) return;

    // Reset file names first to ensure UI update
    setMapaSectoresFileName('Nenhum ficheiro carregado');
    setOtherDocsFileName('Nenhum ficheiro carregado');

    // Fetch new file names with slight delay to ensure backend is queried freshly
    setTimeout(async () => {
      const mapaNome = await fetchMapaSectoresFileName(cultureId);
      if (mapaNome) setMapaSectoresFileName(mapaNome);

      const otherNome = await fetchOtherDocsFileName(cultureId);
      if (otherNome) setOtherDocsFileName(otherNome);
    }, 100);
  };
  /*   const [IfapPdfFileName, setIfapPdfFileName] = useState(
    'Nenhum ficheiro carregado'
  );*/
  const [isEditingPersonal, setIsEditingPersonal] = useState(false);
  const [isEditingCompany, setIsEditingCompany] = useState(false);
  const [updateKey, setUpdateKey] = useState(0);
  const [pdfFile, setPdfFile] = useState(null);
  const [IfapPdfFile, setIfapPdfFile] = useState(null);
  const [IfapPdfFileName, setIfapPdfFileName] = useState(
    'Nenhum ficheiro carregado'
  );
  const [shouldFetchPdfFile, setShouldFetchPdfFile] = useState(false);
  const [estadosChoices, setEstadosChoices] = useState([]);
  const [lastRefresh, setLastRefresh] = useState(Date.now());
  const [isRefreshing, setIsRefreshing] = useState(false);

  // Update local state when user data changes
  useEffect(() => {
    if (user) {
      setName(user?.first_name || '');
      setSurname(user?.last_name || '');
      setPersonalPhone(user?.user_telefone || '');
      setEmail(user?.email || '');
      setCompanyName(user?.organizacao_nome || '');
      setCompanyAddress(user?.organizacao_morada || '');
      setCompanyPhone(user?.organizacao_telefone || '');
      setCompanyEmail(user?.organizacao_email || '');
      setIfapNumber(user?.ifap_number || '');
      setProfilePhoto(user?.profile_photo || '');
    }
  }, [user]);

  // Função para a foto de Perfil.
  const handleProfilePhotoChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        const photoUrl = await uploadProfilePhoto(file); // Upload the photo and get the URL
        setProfilePhoto(photoUrl); // Set the photo URL
        setShouldFetchProfilePhoto(true); // Indicate that the profile photo should be fetched

        // Refresh user data from backend after photo upload
        const refreshedUser = await refreshUserData();
        if (refreshedUser) {
          // User state has been updated in auth context
          console.log('User data refreshed after photo upload');
        }
      } catch (err) {
        console.error('Error uploading photo:', err);
      }
    }
  };

  // Função para buscar a foto de perfil do backend.
  const fetchProfilePhoto = useCallback(async () => {
    if (!user || !user.id) return; // Verifique se user e user.id existem
    try {
      const photoUrl = await getProfilePhoto(user.id); // Fetch the photo URL from the backend
      setProfilePhoto(photoUrl); // Set the photo URL
    } catch (err) {
      console.error('Error fetching profile photo:', err);
    }
  }, [user]); // Use optional chaining para evitar erros

  // useEffect to update profile photo when it changes
  useEffect(() => {
    if (shouldFetchProfilePhoto) {
      fetchProfilePhoto();
      setShouldFetchProfilePhoto(false); // Reset the flag after fetching the photo
    }
  }, [fetchProfilePhoto, shouldFetchProfilePhoto]);

  // Função para os carregamento dos ficheiros PDF.
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      try {
        const fileUrl = await uploadPdfFile(file);
        setPdfFile(fileUrl);
        setPdfFileName(fileUrl.name);
        setShouldFetchPdfFile(true); // Indicate that the PDF file should be fetched
      } catch (err) {
        console.error('Error uploading PDF file:', err);
      }
    } else {
      setPdfFileName('Nenhum ficheiro carregado');
      alert('Por favor, carregue um ficheiro PDF.');
    }
  };

  // Função específica para o carregamento do PDF de IFAP
  const handleIfapFileChange = async (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      try {
        const fileUrl = await uploadPdfFile(file);
        setIfapPdfFile(fileUrl);
        setIfapPdfFileName(file.name);
        setShouldFetchPdfFile(true);

        // Refresh user data from backend after IFAP PDF upload
        const refreshedUser = await refreshUserData();
        if (refreshedUser) {
          // User state has been updated in auth context
          console.log('User data refreshed after IFAP PDF upload');
        }
      } catch (err) {
        console.error('Error uploading IFAP PDF file:', err);
      }
    } else {
      setIfapPdfFileName('Nenhum ficheiro carregado');
      alert('Por favor, carregue um ficheiro PDF.');
    }
  };

  // Função específica para o carregamento do PDF de mapa dos setores de rega
  const handleMapaSectoresFileChange = async (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      try {
        setMapaSectoresFile(file); // Store the file for later upload
        setMapaSectoresFileName(file.name);

        // If editing an existing culture, upload the file immediately
        if (isEditingCulture && currentCulture.id) {
          await uploadWaterMapFileForCulture(file, currentCulture.id);
        }
      } catch (err) {
        console.error('Error uploading mapa de setores PDF file:', err);
      }
    } else {
      setMapaSectoresFile(null);
      setMapaSectoresFileName('Nenhum ficheiro carregado');
      alert('Por favor, carregue um ficheiro PDF.');
    }
  };

  // Função para outros documentos PDF
  const handleOtherDocsFileChange = async (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      try {
        setOtherDocsFile(file); // Store the file for later upload
        setOtherDocsFileName(file.name);

        // If editing an existing culture, upload the file immediately
        if (isEditingCulture && currentCulture.id) {
          await uploadOtherDocsFileForCulture(file, currentCulture.id);
        }
      } catch (err) {
        console.error('Error uploading other documents PDF file:', err);
      }
    } else {
      setOtherDocsFile(null);
      setOtherDocsFileName('Nenhum ficheiro carregado');
      alert('Por favor, carregue um ficheiro PDF.');
    }
  };

  // Função para buscar o PDF do backend.
  const fetchIFAP_PdfFile = useCallback(async () => {
    if (!user || !user.id) return; // Verifique se user e user.id existem
    try {
      const pdf = await getIFAP_PdfFile(user.id); // Fetch the PDF URL from the backend
      /*       console.log('PDF:', pdf); // Debug log */
      if (pdf) {
        /*         console.log('inside the ifap PDF '); // Debug log */
        setIfapPdfFile(pdf);
        setIfapPdfFileName('IFAP PDF'); // Extract and set the file name
      }
    } catch (err) {
      console.error('Error fetching PDF file:', err);
    }
  }, [user]); // Use optional chaining para evitar erros

  // useEffect to fetch the stored PDF file when the component mounts
  useEffect(() => {
    if (isAuthenticated) {
      fetchIFAP_PdfFile(); // Ensure this function is memoized
    }
  }, [isAuthenticated, fetchIFAP_PdfFile]); // Added fetchIFAP_PdfFile to dependencies as it's memoized

  // useEffect to update profile photo and PDF file when they change
  useEffect(() => {
    if (shouldFetchProfilePhoto) {
      fetchProfilePhoto(); // Ensure this function is memoized
      setShouldFetchProfilePhoto(false); // Reset the flag after fetching the photo
    }
    if (shouldFetchPdfFile) {
      fetchIFAP_PdfFile();
      setShouldFetchPdfFile(false); // Reset the flag after fetching the PDF file
    }
  }, [
    shouldFetchProfilePhoto,
    shouldFetchPdfFile,
    fetchProfilePhoto,
    fetchIFAP_PdfFile,
  ]);

  useEffect(() => {
    if (isAuthenticated) {
      getEstadosChoices();
      // ...existing code...
    }
  }, [isAuthenticated]);

  // Função para salvar e editar as informações do perfil do representante.
  const handlePersonalFormSubmit = async (e) => {
    e.preventDefault();
    const userData = {
      name,
      surname,
      personalPhone,
      email,
      companyName,
      companyAddress,
      companyEmail,
      companyPhone,
      ifapNumber,
      profilePhoto,
    };

    try {
      setIsRefreshing(true);
      // Update the user data in backend
      await updateUserData(userData, token);
      // Refresh user data from backend using auth context
      const refreshedUser = await refreshUserData();
      if (refreshedUser) {
        // User state has been updated in auth context
        console.log('User data refreshed after personal info update');
      }
      // Exit edit mode and re-render
      setIsEditingPersonal(false);
      setUpdateKey((prev) => prev + 1);
    } catch (err) {
      console.error('Error saving data:', err);
      alert('Failed to save data. Please try again.');
    } finally {
      setIsRefreshing(false);
    }
  }; // Função para salvar e editar
  const handleEditPersonalClick = () => {
    setIsEditingPersonal(true);
    setUpdateKey((prev) => prev + 1);
  };

  // Função para salvar e editar as informações do perfil da empresa.
  const handleCompanyFormSubmit = async (e) => {
    e.preventDefault();
    const userData = {
      companyName,
      companyAddress,
      companyEmail,
      companyPhone,
      ifapNumber,
    };

    try {
      setIsRefreshing(true);
      // Update the user data in backend
      await updateUserData(userData, token);
      // Refresh user data from backend using auth context
      const refreshedUser = await refreshUserData();
      if (refreshedUser) {
        // User state has been updated in auth context
        console.log('User data refreshed after company info update');
      }
      // Exit edit mode and re-render
      setIsEditingCompany(false);
      setUpdateKey((prev) => prev + 1);
    } catch (err) {
      console.error('Error saving data:', err);
      alert('Failed to save data. Please try again.');
    } finally {
      setIsRefreshing(false);
    }
  };
  const handleEditCompanyClick = () => {
    setIsEditingCompany(true);
    setUpdateKey((prev) => prev + 1);
  };

  // Função que garante que os campos numéricos aceitam apenas números.
  const handleNumberInputKeyPress = (event) => {
    // Check if the key is not a digit and not a control key (like backspace, delete, arrows)
    if (
      !/^\d$/.test(event.key) &&
      !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(
        event.key
      )
    ) {
      event.preventDefault();
    }
  };

  //  --------------- Lógica da Exploração. --------------- //

  const [showExplorationCard, setShowExplorationCard] = useState(false);
  const [explorationTitle, setExplorationTitle] = useState('');
  const [isEditingExploration, setIsEditingExploration] = useState(false);
  const [explorations, setExplorations] = useState(
    JSON.parse(sessionStorage.getItem('exploracoes'))
  ); // Initialize explorations from sessionStorage
  const [currentExploration, setCurrentExploration] = useState({});
  const [isExplorationSaved, setIsExplorationSaved] = useState(
    explorations && explorations.length > 0
  ); // Set to true if there are explorations
  const [location, setLocation] = useState('');
  const [totalArea, setTotalArea] = useState(0);
  const [productiveArea, setProductiveArea] = useState(0);
  const [workforce, setWorkforce] = useState(0);
  const [productionMethod, setProductionMethod] = useState('');
  const [certification, setCertification] = useState('');
  const [waterCapture, setWaterCapture] = useState('');
  const [isExplorationFormValid, setIsExplorationFormValid] = useState(false);
  const [explorationId, setExplorationId] = useState(null);

  const [isExplorationTitleEmpty, setIsExplorationTitleEmpty] = useState(false);
  const [isLocationEmpty, setIsLocationEmpty] = useState(false);
  const [isTotalAreaEmpty, setIsTotalAreaEmpty] = useState(false);
  const [isProductiveAreaEmpty, setIsProductiveAreaEmpty] = useState(false);
  const [isWorkforceEmpty, setIsWorkforceEmpty] = useState(false);
  const [isProductionMethodEmpty, setIsProductionMethodEmpty] = useState(false);
  const [isCertificationEmpty, setIsCertificationEmpty] = useState(false);
  const [isWaterCaptureEmpty, setIsWaterCaptureEmpty] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [cultures, setCultures] = useState([]); // Initialize cultures

  const checkExplorationInputs = () => {
    const errors = [];
    setIsExplorationTitleEmpty((explorationTitle?.trim() || '') === '');
    setIsLocationEmpty((location?.trim() || '') === '');
    setIsTotalAreaEmpty(Number(totalArea) <= 0);
    setIsProductiveAreaEmpty(Number(productiveArea) <= 0);
    setIsWorkforceEmpty(Number(workforce) <= 0);
    setIsProductionMethodEmpty((productionMethod?.trim() || '') === '');
    // Only require certification if production method is not "Convencional"
    setIsCertificationEmpty(
      productionMethod !== 'prod-convencional' &&
        (certification?.trim() || '') === ''
    );
    setIsWaterCaptureEmpty((waterCapture?.trim() || '') === '');

    if ((explorationTitle?.trim() || '') === '') {
      errors.push('O nome da exploração é obrigatório.');
    }
    if ((location?.trim() || '') === '') {
      errors.push('A localização é obrigatória.');
    }
    if (Number(totalArea) <= 0) {
      errors.push('A área total deve ser maior que zero.');
    }
    if (Number(productiveArea) <= 0) {
      errors.push('A área produtiva deve ser maior que zero.');
    }
    if (Number(workforce) <= 0) {
      errors.push('O número de trabalhadores deve ser maior que zero.');
    }
    if ((productionMethod?.trim() || '') === '') {
      errors.push('O método de produção é obrigatório.');
    }
    // Only require certification if production method is not "Convencional"
    if (
      productionMethod !== 'prod-convencional' &&
      (certification?.trim() || '') === ''
    ) {
      errors.push('A certificação é obrigatória.');
    }
    if ((waterCapture?.trim() || '') === '') {
      errors.push('A captação de água é obrigatória.');
    }

    setErrorMessages(errors);
  };

  useEffect(() => {
    checkExplorationInputs();
  }, [
    explorationTitle,
    location,
    totalArea,
    productiveArea,
    workforce,
    productionMethod,
    certification,
    waterCapture,
  ]);

  const validateExplorationForm = useCallback(() => {
    return (
      (explorationTitle?.trim() || '') !== '' &&
      (location?.trim() || '') !== '' &&
      Number(totalArea) > 0 &&
      Number(productiveArea) > 0 &&
      Number(workforce) > 0 &&
      (productionMethod?.trim() || '') !== '' &&
      // Only require certification if production method is not "Convencional"
      (productionMethod === 'prod-convencional' ||
        (certification?.trim() || '') !== '') &&
      (waterCapture?.trim() || '') !== ''
    );
  }, [
    explorationTitle,
    location,
    totalArea,
    productiveArea,
    workforce,
    productionMethod,
    certification,
    waterCapture,
  ]);

  useEffect(() => {
    setIsExplorationFormValid(validateExplorationForm());
  }, [validateExplorationForm]);

  // Função que permite adicionar uma nova exploração.
  const handleAddExploration = () => {
    // Reset all form fields for new exploration
    setExplorationTitle('');
    setLocation('');
    setTotalArea(0);
    setProductiveArea(0);
    setWorkforce(0);
    setProductionMethod('');
    setCertification('');
    setWaterCapture('');
    setExplorationId(null);
    setIsEditingExploration(false);
    setShowExplorationCard(true);
  };

  // Função que muda o nome da exploração.
  const handleExplorationNameChange = (event) => {
    setExplorationTitle(event.target.value);
  };

  // Função que salva a exploração.
  const handleSaveExploration = async () => {
    if (validateExplorationForm()) {
      try {
        setIsRefreshing(true); // Set refreshing state to true
        const explorationData = {
          id: explorationId, // Add the exploration ID if it exists
          title: explorationTitle,
          location,
          total_area: totalArea,
          productive_area: productiveArea, // Change to productive_area
          workforce,
          production_method: productionMethod,
          certifications: certification,
          water_capture: waterCapture,
          user: user.id,
        };
        const savedExploration = await saveExplorationData(explorationData); // Save exploration data to the backend
        setExplorations((prevExplorations) => [
          ...prevExplorations.filter((exp) => exp.id !== explorationId),
          savedExploration,
        ]);
        sessionStorage.setItem(
          'exploracoes',
          JSON.stringify([
            ...explorations.filter((exp) => exp.id !== explorationId),
            savedExploration,
          ])
        ); // Update sessionStorage
        setCurrentExploration({});
        setIsExplorationSaved(true);
        setShowExplorationCard(false);
        setIsEditingExploration(false);
        setExplorationId(null); // Reset the exploration ID

        // Refresh data after saving
        await refreshExplorations();
      } catch (error) {
        console.error('Error saving exploration data:', error);
      }
    }
  };

  // Função que edita a exploração.
  const handleEditExploration = async (exploration) => {
    try {
      console.log('Fetching exploration details for ID:', exploration.id);

      // Fetch the complete exploration data from the backend
      const explorationDetails = await fetchExplorationById(exploration.id);
      console.log('Exploration details received:', explorationDetails);

      setCurrentExploration(explorationDetails);

      // Set form fields with the data from backend
      setExplorationTitle(explorationDetails.title || '');
      setLocation(explorationDetails.location || '');
      setTotalArea(Number(explorationDetails.total_area || 0));
      setProductiveArea(Number(explorationDetails.productive_area || 0));
      setWorkforce(Number(explorationDetails.workforce || 0));
      setProductionMethod(explorationDetails.production_method || '');
      setCertification(explorationDetails.certifications || '');
      setWaterCapture(explorationDetails.water_capture || '');

      setIsEditingExploration(true);
      setShowExplorationCard(true);
      setExplorationId(exploration.id);
      setCultures(explorationDetails.culturas || []);
    } catch (error) {
      console.error('Error fetching exploration details:', error);
      alert('Erro ao carregar os detalhes da exploração. Tente novamente.');
    }
  };

  // --------------- Lógica das Culturas. --------------- //

  const [currentCulture, setCurrentCulture] = useState({
    cultureTitle: '',
    cultureType: '',
    cultureSpecie: '',
    cultureArea: 0,
    cultureCompass: '',
    cultureWateringType: '',
    cultureWateringNumber: 0,
    cultureSoilType: '',
    cultureProduction: 0,
    cultureProductionSector: 0,
    cultureProductionHectare: 0,
    cultureYearType: '',
  });
  const [isSaveButtonEnabled, setIsSaveButtonEnabled] = useState(false);
  const [isEditingCulture, setIsEditingCulture] = useState(false);
  const [showCultureCard, setShowCultureCard] = useState(false);
  const [showExplorationCultureCard, setShowExplorationCultureCard] =
    useState(null);
  const [isCultureSaved, setIsCultureSaved] = useState(false);
  const [editingCultureId, setEditingCultureId] = useState(null); // Add this state

  const [isCultureTitleEmpty, setIsCultureTitleEmpty] = useState(false);
  const [isCultureIndicatorEmpty, setIsCultureIndicatorEmpty] = useState(false);
  const [isCultureTypeEmpty, setIsCultureTypeEmpty] = useState(false);
  const [isCultureSpecieEmpty, setIsCultureSpecieEmpty] = useState(false);
  const [isCultureAreaEmpty, setIsCultureAreaEmpty] = useState(false);
  const [isCultureCompassEmpty, setIsCultureCompassEmpty] = useState(false);
  const [isCultureWateringTypeEmpty, setIsCultureWateringTypeEmpty] =
    useState(false);
  const [isCultureWateringNumberEmpty, setIsCultureWateringNumberEmpty] =
    useState(false);
  const [isCultureSoilTypeEmpty, setIsCultureSoilTypeEmpty] = useState(false);
  const [isCultureProductionEmpty, setIsCultureProductionEmpty] =
    useState(false);
  const [isCultureProductionSectorEmpty, setIsCultureProductionSectorEmpty] =
    useState(false);
  const [isCultureProductionHectareEmpty, setIsCultureProductionHectareEmpty] =
    useState(false);
  const [isCultureYearTypeEmpty, setIsCultureYearTypeEmpty] = useState(false);
  const [tipoCulturaChoices, setTipoCulturaChoices] = useState([]);
  const [tipoProducaoChoices, setTipoProducaoChoices] = useState([]);
  const [tipoSistemaRegaChoices, setTipoSistemaRegaChoices] = useState([]);
  const [classeTexturalChoices, setClasseTexturalChoices] = useState([]);
  const [caracteristicasAnoChoices, setCaracteristicasAnoChoices] = useState(
    []
  );
  const [isCultureTypeInvalid, setIsCultureTypeInvalid] = useState(false);
  const [isProducaoTypeInvalid, setIsProducaoTypeInvalid] = useState(false);
  const [isSistemaRegaTypeInvalid, setIsSistemaRegaTypeInvalid] =
    useState(false);
  const [isClasseTexturalInvalid, setIsClasseTexturalInvalid] = useState(false);
  const [isCaracteristicasAnoInvalid, setIsCaracteristicasAnoInvalid] =
    useState(false);

  useEffect(() => {
    const fetchChoices = async () => {
      try {
        const [
          tipoCultura,
          tipoProducao,
          tipoSistemaRega,
          classeTextural,
          caracteristicasAno,
        ] = await Promise.all([
          getTipoCulturaChoices(),
          getTipoProducaoChoices(),
          getTipoSistemaRegaChoices(),
          getClasseTexturalChoices(),
          getCaracteristicasAnoChoices(),
        ]);

        setTipoCulturaChoices(tipoCultura.choices || []);
        setTipoProducaoChoices(tipoProducao.choices || []); // Ensure it's an array
        setTipoSistemaRegaChoices(tipoSistemaRega.choices || []);
        setClasseTexturalChoices(classeTextural.choices || []);
        setCaracteristicasAnoChoices(caracteristicasAno.choices || []);
      } catch (error) {
        console.error('Error fetching choices:', error);
        // Check if error is auth-related
        if (error.response?.status === 401) {
          console.error('Authentication error while fetching choices');
          // Handle auth error appropriately without triggering unintended logout
        }
      }
    };

    if (isAuthenticated) {
      fetchChoices();
      fetchProfilePhoto(); // Fetch the profile photo when the component mounts
    }
  }, [isAuthenticated]); // Add isAuthenticated as dependency

  const handleCultureChange = (event) => {
    const { name, value } = event.target;
    setCurrentCulture((prevCulture) => ({
      ...prevCulture,
      [name]: value,
    }));
  };

  const validateCultureForm = useCallback(() => {
    const {
      cultureTitle,
      cultureIndicator,
      cultureType,
      cultureSpecie,
      cultureArea,
      cultureCompass,
      cultureWateringType,
      cultureWateringNumber,
      cultureSoilType,
      cultureProduction,
      cultureProductionSector,
      cultureProductionHectare,
      cultureYearType,
      cultureCulturaType,
    } = currentCulture;

    /*     console.log('tipoCulturaChoices:', tipoCulturaChoices); // Debug log
    console.log('tipoProducaoChoices:', tipoProducaoChoices); // Debug log
    console.log('tipoSistemaRegaChoices:', tipoSistemaRegaChoices); // Debug log
    console.log('classeTexturalChoices:', classeTexturalChoices); // Debug log
    console.log('caracteristicasAnoChoices:', caracteristicasAnoChoices); // Debug log */

    const isValidCultureType =
      Array.isArray(tipoCulturaChoices) &&
      tipoCulturaChoices.some((choice) => choice[0] === cultureCulturaType);
    const isValidProducaoType =
      Array.isArray(tipoProducaoChoices) &&
      tipoProducaoChoices.some((choice) => choice[0] === cultureType);
    const isValidSistemaRegaType =
      Array.isArray(tipoSistemaRegaChoices) &&
      tipoSistemaRegaChoices.some(
        (choice) => choice[0] === cultureWateringType
      );
    const isValidClasseTextural =
      Array.isArray(classeTexturalChoices) &&
      classeTexturalChoices.some((choice) => choice[0] === cultureSoilType);
    const isValidCaracteristicasAno =
      Array.isArray(caracteristicasAnoChoices) &&
      caracteristicasAnoChoices.some((choice) => choice[0] === cultureYearType);
    setIsCultureTypeInvalid(!isValidCultureType);
    setIsProducaoTypeInvalid(!isValidProducaoType);
    setIsSistemaRegaTypeInvalid(!isValidSistemaRegaType);
    setIsClasseTexturalInvalid(!isValidClasseTextural);
    setIsCaracteristicasAnoInvalid(!isValidCaracteristicasAno);

    return (
      (cultureTitle?.trim() || '') !== '' &&
      (cultureIndicator?.trim() || '') !== '' &&
      (cultureType?.trim() || '') !== '' &&
      (cultureSpecie?.trim() || '') !== '' &&
      cultureArea > 0 &&
      (cultureCompass?.trim() || '') !== '' &&
      (cultureWateringType?.trim() || '') !== '' &&
      cultureWateringNumber > 0 &&
      (cultureSoilType?.trim() || '') !== '' &&
      cultureProduction > 0 &&
      cultureProductionSector > 0 &&
      cultureProductionHectare > 0 &&
      (cultureYearType?.trim() || '') !== '' &&
      isValidCultureType && // Ensure cultureCulturaType is within available choices
      isValidProducaoType && // Ensure cultureType is within available choices
      isValidSistemaRegaType && // Ensure cultureWateringType is within available choices
      isValidClasseTextural && // Ensure cultureSoilType is within available choices
      isValidCaracteristicasAno // Ensure cultureCaracteristicasAno is within available choices
    );
  }, [
    currentCulture,
    tipoCulturaChoices,
    tipoProducaoChoices,
    tipoSistemaRegaChoices,
    classeTexturalChoices,
    caracteristicasAnoChoices,
  ]);

  useEffect(() => {
    setIsSaveButtonEnabled(validateCultureForm());
  }, [currentCulture, validateCultureForm]);

  const refreshExplorations = async () => {
    try {
      const exploracoes = await fetchExploracoes(user.id);
      setExplorations(exploracoes.exploracoes);
      sessionStorage.setItem(
        'exploracoes',
        JSON.stringify(exploracoes.exploracoes)
      );
      await fetchEstadosChoices();
      setLastRefresh(Date.now());
    } catch (error) {
      console.error('Error refreshing explorations:', error);
    } finally {
      setIsRefreshing(false);
    }
  };

  const handleSaveCulture = async () => {
    const {
      cultureTitle,
      cultureIndicator,
      cultureType,
      cultureSpecie,
      cultureArea,
      cultureCompass,
      cultureWateringType,
      cultureWateringNumber,
      cultureSoilType,
      cultureProduction,
      cultureProductionSector,
      cultureProductionHectare,
      cultureYearType,
      cultureCulturaType,
    } = currentCulture;

    setIsCultureTitleEmpty((cultureTitle?.trim() || '') === '');
    setIsCultureIndicatorEmpty((cultureIndicator?.trim() || '') === '');
    setIsCultureTypeEmpty(
      (cultureType?.trim() || '') === '' ||
        !tipoProducaoChoices.some((choice) => choice[0] === cultureType)
    );
    setIsCultureSpecieEmpty((cultureSpecie?.trim() || '') === '');
    setIsCultureAreaEmpty(cultureArea <= 0);
    setIsCultureCompassEmpty((cultureCompass?.trim() || '') === '');
    setIsCultureWateringTypeEmpty(
      (cultureWateringType?.trim() || '') === '' ||
        !tipoSistemaRegaChoices.some(
          (choice) => choice[0] === cultureWateringType
        )
    );
    setIsCultureWateringNumberEmpty(cultureWateringNumber <= 0);
    setIsCultureSoilTypeEmpty(
      (cultureSoilType?.trim() || '') === '' ||
        !classeTexturalChoices.some((choice) => choice[0] === cultureSoilType)
    );
    setIsCultureProductionEmpty(cultureProduction <= 0);
    setIsCultureProductionSectorEmpty(cultureProductionSector <= 0);
    setIsCultureProductionHectareEmpty(cultureProductionHectare <= 0);
    setIsCultureYearTypeEmpty((cultureYearType?.trim() || '') === '');
    setIsCultureTypeInvalid(
      !tipoCulturaChoices.some((choice) => choice[0] === cultureCulturaType)
    );

    if (
      (cultureTitle?.trim() || '') !== '' &&
      (cultureIndicator?.trim() || '') !== '' &&
      (cultureType?.trim() || '') !== '' &&
      (cultureSpecie?.trim() || '') !== '' &&
      cultureArea > 0 &&
      (cultureCompass?.trim() || '') !== '' &&
      (cultureWateringType?.trim() || '') !== '' &&
      cultureWateringNumber > 0 &&
      (cultureSoilType?.trim() || '') !== '' &&
      cultureProduction > 0 &&
      cultureProductionSector > 0 &&
      cultureProductionHectare > 0 &&
      (cultureYearType?.trim() || '') !== '' &&
      tipoCulturaChoices.some((choice) => choice[0] === cultureCulturaType) &&
      tipoProducaoChoices.some((choice) => choice[0] === cultureType) &&
      tipoSistemaRegaChoices.some(
        (choice) => choice[0] === cultureWateringType
      ) &&
      classeTexturalChoices.some((choice) => choice[0] === cultureSoilType)
      // &&
      // caracteristicasAnoChoices.some(
      //   (choice) => choice[0] === cultureCaracteristicasAno
      // )
    ) {
      try {
        setIsRefreshing(true); // Set refreshing state to true
        // Create FormData object and populate it with culture data
        const formData = new FormData();

        // Main culture information
        formData.append('nome', currentCulture.cultureTitle || '');
        formData.append(
          'indicador_adequado',
          currentCulture.cultureIndicator || ''
        );
        formData.append('tipo_producao', currentCulture.cultureType || '');
        formData.append('cultura', currentCulture.cultureCulturaType || '');
        formData.append('variedade', currentCulture.cultureSpecie || '');

        // Area and production details
        formData.append('area_cultura', currentCulture.cultureArea || 0);
        formData.append('compasso', currentCulture.cultureCompass || '');
        formData.append(
          'producao_cultura',
          currentCulture.cultureProduction || 0
        );
        formData.append(
          'producao_hectare',
          currentCulture.cultureProductionHectare || 0
        );

        // Watering system details
        formData.append(
          'tipo_sistema_rega',
          currentCulture.cultureWateringType || ''
        );
        formData.append(
          'numero_setores_rega',
          currentCulture.cultureWateringNumber || 0
        );

        // Soil and year characteristics
        formData.append(
          'classe_textural_solo',
          currentCulture.cultureSoilType || ''
        );
        formData.append(
          'caracteristica_ano',
          currentCulture.cultureYearType || ''
        );

        // Exploration ID (required for association)
        formData.append('exploracao', currentExploration.id);

        // Optional PDF files
        if (mapaSectoresFile && mapaSectoresFile instanceof File) {
          formData.append('mapa_setores_rega', mapaSectoresFile);
        }

        if (otherDocsFile && otherDocsFile instanceof File) {
          formData.append('outros_documentos', otherDocsFile);
        }

        // If editing existing culture, include the ID
        if (isEditingCulture && currentCulture.id) {
          formData.append('id', currentCulture.id);
        }

        // Log FormData content for debugging
        // console.log('FormData content:');
        // for (let pair of formData.entries()) {
        //   console.log(pair[0] + ': ' + pair[1]);
        // }

        const savedCulture = await saveCultureData(formData); // Save culture data to the backend
        setCultures((prevCultures) =>
          isEditingCulture
            ? prevCultures.map((culture) =>
                culture.id === currentCulture.id ? savedCulture : culture
              )
            : [...prevCultures, savedCulture]
        );
        setShowCultureCard(false);
        setShowExplorationCultureCard(null);
        setIsEditingCulture(false);
        setIsCultureSaved(true);

        // Reset culture form
        setCurrentCulture({
          cultureTitle: '',
          cultureType: '',
          cultureSpecie: '',
          cultureArea: 0,
          cultureCompass: '',
          cultureWateringType: '',
          cultureWateringNumber: 0,
          cultureSoilType: '',
          cultureProduction: 0,
          cultureProductionSector: 0,
          cultureProductionHectare: 0,
          cultureYearType: '',
        });

        // Reset all validation states
        setIsCultureTitleEmpty(false);
        setIsCultureIndicatorEmpty(false);
        setIsCultureTypeEmpty(false);
        setIsCultureSpecieEmpty(false);
        setIsCultureAreaEmpty(false);
        setIsCultureCompassEmpty(false);
        setIsCultureWateringTypeEmpty(false);
        setIsCultureWateringNumberEmpty(false);
        setIsCultureSoilTypeEmpty(false);
        setIsCultureProductionEmpty(false);
        setIsCultureProductionSectorEmpty(false);
        setIsCultureProductionHectareEmpty(false);
        setIsCultureYearTypeEmpty(false);
        setIsCultureTypeInvalid(false);
        setIsProducaoTypeInvalid(false);
        setIsSistemaRegaTypeInvalid(false);
        setIsClasseTexturalInvalid(false);
        setIsCaracteristicasAnoInvalid(false);

        // Reset editing state
        setEditingCultureId(null);

        // Refresh explorations and cultures data
        await refreshExplorations();

        // Force component re-render by updating lastRefresh
        setLastRefresh(Date.now());

        // Show success message
        alert('Cultura guardada com sucesso!');
      } catch (error) {
        console.error('Error saving culture data:', error);
        alert('Erro ao guardar a cultura. Tente novamente.');
      } finally {
        setIsRefreshing(false); // Ensure refreshing state is reset
      }
    } else {
      alert('Por favor, preencha todos os campos obrigatórios.');
    }
  };

  const handleAddCulture = (exploration) => {
    const newCulture = {
      id: Date.now(),
      cultureTitle: '',
      cultureType: '',
      cultureSpecie: '',
      cultureArea: 0,
      cultureCompass: '',
      cultureWateringType: '',
      cultureWateringNumber: 0,
      cultureSoilType: '',
      cultureProduction: 0,
      cultureProductionSector: 0,
      cultureProductionHectare: 0,
      cultureYearType: '',
    };

    setCurrentExploration(exploration); // Set the current exploration
    setCurrentCulture(newCulture);
    // Reset file states for new culture
    setMapaSectoresFile(null);
    setOtherDocsFile(null);
    setMapaSectoresFileName('Nenhum ficheiro carregado');
    setOtherDocsFileName('Nenhum ficheiro carregado');
    setShowCultureCard(true);
    setShowExplorationCultureCard(exploration);
    setIsEditingCulture(false);
    setIsCultureSaved(false);
  };

  const handleEditCulture = (exploration, culture) => {
    setEditingCultureId(culture.id);
    setCurrentExploration(exploration);
    setCurrentCulture({
      id: culture.id,
      cultureTitle: culture.nome,
      cultureSpecie: culture.variedade,
      cultureIndicator: culture.indicador_adequado,
      cultureType: culture.tipo_producao,
      cultureCulturaType: culture.cultura,
      cultureArea: culture.area_cultura,
      cultureCompass: culture.compasso,
      cultureWateringType: culture.tipo_sistema_rega,
      cultureWateringNumber: culture.numero_setores_rega,
      cultureSoilType: culture.classe_textural_solo,
      cultureProduction: culture.producao_cultura,
      cultureProductionSector: culture.producao_hectare,
      cultureProductionHectare: culture.producao_hectare,
      cultureYearType: culture.caracteristica_ano,
    });
    // Reset file states when editing existing culture
    setMapaSectoresFile(null);
    setOtherDocsFile(null);
    updateCultureFileNames(culture.id);
    setShowCultureCard(true);
    setShowExplorationCultureCard(exploration);
    setIsEditingCulture(true);
  };

  const exploracao_vazia_message =
    'Não existe nenhuma culturas registada. Por favor, adicione uma culturas para poder criar a respetiva certificação.';

  // Função para abrir o PDF do IFAP
  const handleOpenIfapPdf = async () => {
    try {
      const { url, isPdf } = await getIFAP_PdfFile(user.id);
      if (isPdf) {
        window.open(url, '_blank'); // Open the PDF in a new tab
      } else {
        alert('The file is not a valid PDF.');
      }
    } catch (err) {
      console.error('Error opening PDF file:', err);
      alert('Failed to open the PDF file.');
    }
  };

  // Função para abrir o PDF do Mapa dos Sectores de Rega
  const handleOpenWaterMapPdf = async (cultureId) => {
    try {
      const { url, isPdf } = await getWaterMapPdfFile(cultureId);
      if (isPdf) {
        window.open(url, '_blank'); // Open the PDF in a new tab
      } else {
        alert('Ficheiro PDF não encontrado ou não é válido.');
      }
    } catch (err) {
      console.error('Error opening water map PDF file:', err);
      alert('Falha ao abrir o ficheiro PDF.');
    }
  };

  // Função para abrir o PDF dos Outros Documentos
  const handleOpenOtherDocsPdf = async (cultureId) => {
    try {
      const { url, isPdf } = await getOtherDocsPdfFile(cultureId);
      if (isPdf) {
        window.open(url, '_blank'); // Open the PDF in a new tab
      } else {
        alert('Ficheiro PDF não encontrado ou não é válido.');
      }
    } catch (err) {
      console.error('Error opening other docs PDF file:', err);
      alert('Falha ao abrir o ficheiro PDF.');
    }
  };

  /**
   * Method to get certificates by cultura_id and ESTADO.
   * @param {number} culturaId - The ID of the cultura.
   * @param {string} estado - The desired ESTADO.
   * @returns {Array} - List of certificates matching the criteria.
   */
  const getCertificatesByCulturaIdAndEstado = useCallback(
    (culturaId, estado) => {
      const matchingCertificates = [];
      explorations.forEach((exploration) => {
        if (exploration.sg_certificados) {
          const filteredCertificates = exploration.sg_certificados.filter(
            (certificado) =>
              certificado.cultura_id === culturaId &&
              certificado.estado === estado
          );
          matchingCertificates.push(...filteredCertificates);
        }
      });
      return matchingCertificates;
    },
    [explorations, lastRefresh]
  ); // Add lastRefresh to dependencies

  /**
   * Method to render certificates grouped by ESTADO.
   * @param {number} culturaId - The ID of the cultura.
   * @returns {JSX.Element} - Rendered tables for each ESTADO.
   */
  const renderCertificatesByCulturaID = useCallback(
    (culturaId) => {
      return estadosChoices.map((estado) => {
        const certificates = getCertificatesByCulturaIdAndEstado(
          culturaId,
          estado
        );

        if (certificates.length === 0) return null;

        return (
          <table
            key={`${estado}-${culturaId}-${lastRefresh}`}
            className="certificates-table"
          >
            <thead>
              <tr>
                <th colSpan="2">{estado}</th>
              </tr>
            </thead>
            <tbody>
              {certificates.map((certificate, index) => (
                <tr key={`${certificate.id || index}-${lastRefresh}`}>
                  <td>
                    {`Avaliação de ${
                      certificate.data_creacao_certificacao
                        ? certificate.data_creacao_certificacao.split(' ')[0]
                        : 'Data não disponível'
                    }`}
                  </td>
                  <td>
                    <button
                      onClick={() => handleGeneratePdf(certificate.id)}
                      className="btn-generate-pdf"
                      title="Generate PDF"
                    >
                      <i className="fa-solid fa-file-pdf"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      });
    },
    [estadosChoices, lastRefresh, getCertificatesByCulturaIdAndEstado]
  );

  // Função para buscar ESTADO_CHOICES
  const fetchEstadosChoices = async () => {
    try {
      const choices = await getEstadosChoices();
      setEstadosChoices(choices); // Store the choices in state
    } catch (error) {
      console.error('Error fetching ESTADO_CHOICES:', error);
    }
  };

  // useEffect to fetch ESTADO_CHOICES when the component mounts
  useEffect(() => {
    if (isAuthenticated) {
      fetchEstadosChoices();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated && user?.id) {
      refreshExplorations();
    }
    // eslint-disable-next-line
  }, [isAuthenticated, user?.id]);

  // Função para gerar e abrir o PDF
  const handleGeneratePdf = async (certId) => {
    try {
      const pdfUrl = await generatePdfForCulture(certId); // Generate the PDF
      window.open(pdfUrl, '_blank'); // Open the PDF in a new tab
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Failed to generate the PDF. Please try again.');
    }
  };

  // --------------- Renderização do Componente --------------- //

  return (
    <section className="profile-container">
      <h1>Página de Perfil</h1>

      {/* --------------- Secção do Perfil Pessoal --------------- */}

      <section className="personal-container">
        <section className="photo-container">
          <div className="card">
            <h3>Foto de Perfil</h3>
            <div className="profile-photo">
              <img src={profilePhoto || placeholderImage} alt="Profile" />
              <input
                type="file"
                accept="image/*"
                onChange={handleProfilePhotoChange}
                style={{ display: 'none' }}
                id="upload-photo"
              />
              <label htmlFor="upload-photo" className="btn-save-edit">
                Carregar Foto
                <i className="fa-solid fa-upload"></i>
              </label>
            </div>
          </div>
        </section>

        <section className="representative-container">
          <div className="card">
            <h3>Informações do Representante</h3>
            <form
              key={updateKey}
              className="profile-form"
              onSubmit={handlePersonalFormSubmit}
            >
              <div className="form-group">
                <label htmlFor="name">Nome:</label>
                <input
                  type="text"
                  id="name-personal"
                  placeholder="Nome"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  disabled={!isEditingPersonal}
                  className={!isEditingPersonal ? 'disabled-input' : ''}
                />
              </div>

              <div className="form-group">
                <label htmlFor="surname">Apelido:</label>
                <input
                  type="text"
                  id="surname-personal"
                  placeholder="Apelido"
                  value={surname}
                  onChange={(e) => setSurname(e.target.value)}
                  required
                  disabled={!isEditingPersonal}
                  className={!isEditingPersonal ? 'disabled-input' : ''}
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone-personal">Telefone Pessoal:</label>
                <input
                  type="text"
                  id="phone-personal"
                  onKeyDown={handleNumberInputKeyPress}
                  value={personalPhone}
                  onChange={(e) => setPersonalPhone(e.target.value)}
                  required
                  disabled={!isEditingPersonal}
                  className={!isEditingPersonal ? 'disabled-input' : ''}
                  min="0"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">E-mail:</label>
                <input
                  type="email"
                  id="email-personal"
                  placeholder="E-mail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={!isEditingPersonal}
                  className={!isEditingPersonal ? 'disabled-input' : ''}
                />
              </div>

              {isEditingPersonal ? (
                <button
                  type="submit"
                  className="btn-save-edit"
                  disabled={isRefreshing}
                >
                  {isRefreshing ? 'A guardar...' : 'Guardar'}
                  <i
                    className={
                      isRefreshing
                        ? 'fa-solid fa-spinner fa-spin'
                        : 'fa-solid fa-floppy-disk'
                    }
                  ></i>
                </button>
              ) : (
                <button
                  type="button"
                  onClick={handleEditPersonalClick}
                  className="btn-save-edit"
                >
                  Editar
                  <i className="fa-solid fa-pen-to-square"></i>
                </button>
              )}
            </form>
          </div>
        </section>
      </section>

      {/* --------------- Secção do Perfil Empresa --------------- */}

      <section className="company-container">
        <div className="card">
          <h3>Dados da Empresa</h3>
          <form
            key={updateKey}
            className="profile-form"
            onSubmit={handleCompanyFormSubmit}
          >
            <div className="form-group">
              <label htmlFor="name-company">Nome:</label>
              <input
                type="text"
                id="name-company"
                placeholder="Nome"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                required
                disabled={!isEditingCompany}
                className={!isEditingCompany ? 'disabled-input' : ''}
              />
            </div>

            <div className="form-group">
              <label htmlFor="adress-company">Morada:</label>
              <input
                type="text"
                id="adress-company"
                placeholder="Morada"
                value={companyAddress}
                onChange={(e) => setCompanyAddress(e.target.value)}
                required
                disabled={!isEditingCompany}
                className={!isEditingCompany ? 'disabled-input' : ''}
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone-company">Telefone:</label>
              <input
                type="text"
                id="phone-company"
                placeholder="Número de Telefone"
                value={companyPhone}
                onChange={(e) => setCompanyPhone(e.target.value)}
                required
                disabled={!isEditingCompany}
                className={!isEditingCompany ? 'disabled-input' : ''}
                min="0"
                onKeyDown={handleNumberInputKeyPress}
              />
            </div>
            <div className="form-group">
              <label htmlFor="email-company">Email:</label>
              <input
                type="email"
                id="email-company"
                placeholder="Email"
                value={companyEmail}
                onChange={(e) => setCompanyEmail(e.target.value)}
                required
                disabled={!isEditingCompany}
                className={!isEditingCompany ? 'disabled-input' : ''}
              />
            </div>

            <div className="form-group">
              <label htmlFor="number-ifap">IFAP:</label>
              <input
                type="text"
                id="number-ifap"
                placeholder="Número IFAP"
                value={ifapNumber}
                onChange={(e) => setIfapNumber(e.target.value)}
                required
                disabled={!isEditingCompany}
                className={!isEditingCompany ? 'disabled-input' : ''}
              />
            </div>

            <div className="pdf-upload">
              <label htmlFor="upload-pdf">PDF IFAP:</label>
              <label htmlFor="upload-pdf-ifap" className="btn-upload">
                {IfapPdfFile ? 'Atualizar IFAP' : 'Carregar IFAP'}
                <i className="fa-solid fa-upload"></i>
              </label>
              <input
                type="file"
                accept="application/pdf"
                onChange={handleIfapFileChange}
                id="upload-pdf-ifap"
                disabled={!isEditingCompany}
              />
              {IfapPdfFile ? (
                <button
                  type="button"
                  onClick={handleOpenIfapPdf}
                  className="pdf-link"
                >
                  {IfapPdfFileName}{' '}
                  {/* <i className="fa-solid fa-external-link-alt"></i> */}
                </button>
              ) : (
                <span className="file-name">{IfapPdfFileName}</span>
              )}
            </div>

            {isEditingCompany ? (
              <button
                type="submit"
                className="btn-save-edit"
                disabled={isRefreshing}
              >
                {isRefreshing ? 'A guardar...' : 'Guardar'}
                <i
                  className={
                    isRefreshing
                      ? 'fa-solid fa-spinner fa-spin'
                      : 'fa-solid fa-floppy-disk'
                  }
                ></i>
              </button>
            ) : (
              <button
                type="button"
                onClick={handleEditCompanyClick}
                className="btn-save-edit"
              >
                Editar
                <i className="fa-solid fa-pen-to-square"></i>
              </button>
            )}
          </form>
        </div>
      </section>

      {/* --------------- Secção da Exploração --------------- */}

      <h2>Explorações & Culturas</h2>

      <div className="exploration-title">
        <p>
          Adicione a exploração e, de seguida, a cultura na exploração. Pode ter
          mais que uma exploração e mais do que uma cultura por exploração.
        </p>
      </div>

      <section className="exploration-container">
        {showExplorationCard && (
          <div className="card">
            <h3>
              {isEditingExploration ? 'Editar Exploração' : 'Nova Exploração'}
            </h3>
            <h4>{explorationTitle || 'Título da Exploração'}</h4>
            <form className="profile-form">
              <div className="form-group">
                <label htmlFor="exploration-name">Nome da Exploração:</label>
                <input
                  id="exploration-name"
                  type="text"
                  placeholder="Digite o nome para a exploração"
                  value={explorationTitle}
                  onChange={handleExplorationNameChange}
                  className={isExplorationTitleEmpty ? 'input-error' : ''}
                />
                {isExplorationTitleEmpty && (
                  <span className="error-message">
                    O nome da exploração é obrigatório.
                  </span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="local">Localização:</label>
                <input
                  id="local"
                  type="text"
                  placeholder="Digite a localização"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                  className={isLocationEmpty ? 'input-error' : ''}
                />
                {isLocationEmpty && (
                  <span className="error-message">
                    A localização é obrigatória.
                  </span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="total-area">Área Total (hectares):</label>
                <input
                  id="total-area"
                  type="number"
                  min="0"
                  onKeyPress={handleNumberInputKeyPress}
                  placeholder="Digite a área total"
                  value={totalArea}
                  onChange={(e) => setTotalArea(e.target.value)}
                  className={isTotalAreaEmpty ? 'input-error' : ''}
                />
                {isTotalAreaEmpty && (
                  <span className="error-message">
                    A área total deve ser maior que zero.
                  </span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="productive-area">
                  Área Produtiva (hectares):
                </label>
                <input
                  id="productive-area"
                  type="number"
                  min="0"
                  onKeyPress={handleNumberInputKeyPress}
                  placeholder="Digite a área produtiva"
                  value={productiveArea}
                  onChange={(e) => setProductiveArea(e.target.value)}
                  className={isProductiveAreaEmpty ? 'input-error' : ''}
                />
                {isProductiveAreaEmpty && (
                  <span className="error-message">
                    A área produtiva deve ser maior que zero.
                  </span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="workforce">Número de Trabalhadores:</label>
                <input
                  id="workforce"
                  type="number"
                  min="0"
                  onKeyPress={handleNumberInputKeyPress}
                  placeholder="Digite o número de trabalhadores"
                  value={workforce}
                  onChange={(e) => setWorkforce(e.target.value)}
                  className={isWorkforceEmpty ? 'input-error' : ''}
                />
                {isWorkforceEmpty && (
                  <span className="error-message">
                    O número de trabalhadores deve ser maior que zero.
                  </span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="production-method">Método de Produção:</label>
                <select
                  id="production-method"
                  required
                  value={productionMethod}
                  onChange={(e) => setProductionMethod(e.target.value)}
                  className={isProductionMethodEmpty ? 'input-error' : ''}
                >
                  <option value="">Opções</option>
                  <option value="prod-convencional">Convencional</option>
                  <option value="prod-biologica">Biológica</option>
                  <option value="prod-integrada">Produção Integrada</option>
                  <option value="prod-regenerativa">Regenerativa</option>
                </select>
                {isProductionMethodEmpty && (
                  <span className="error-message">
                    O método de produção é obrigatório.
                  </span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="certifications">Certificações:</label>
                <select
                  id="certifications"
                  required={productionMethod !== 'prod-convencional'}
                  value={certification}
                  onChange={(e) => setCertification(e.target.value)}
                  className={isCertificationEmpty ? 'input-error' : ''}
                >
                  <option value="">
                    {productionMethod === 'prod-convencional'
                      ? 'Nenhuma (Opcional)'
                      : 'Opções'}
                  </option>
                  <option value="cert-biologica">Produção Biológica</option>
                  <option value="cert-integrada">Produção Integrada</option>
                  <option value="cert-grasp">GRASP</option>
                </select>
                {isCertificationEmpty && (
                  <span className="error-message">
                    A certificação é obrigatória.
                  </span>
                )}
                <div className="form-group">
                  <label htmlFor="cert-pdf" className="cert-exploration">
                    Carregar PDF
                  </label>
                  <label htmlFor="upload-pdf" className="btn-upload">
                    Carregar PDF
                    <i className="fa-solid fa-upload"></i>
                  </label>
                  <input
                    type="file"
                    accept="application/pdf"
                    onChange={handleFileChange}
                    id="upload-pdf"
                  />
                  <span className="file-name">{pdfFileName}</span>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="water-capture">Captação de Água:</label>
                <select
                  id="water-capture"
                  required
                  value={waterCapture}
                  onChange={(e) => setWaterCapture(e.target.value)}
                  className={isWaterCaptureEmpty ? 'input-error' : ''}
                >
                  <option value="">Opções</option>
                  <option value="cap-furo">Subterrânea (furo)</option>
                  <option value="cap-superficial">
                    Superficial (albufeira, barragem, rio)
                  </option>
                  <option value="cap-rega">Perímetro de Rega</option>
                  <option value="cap-chuva">
                    Armazenamento de Águas da Chuva
                  </option>
                  <option value="cap-tratadas">
                    Reutilização de Águas Tratadas (incluindo drenantes)
                  </option>
                </select>
                {isWaterCaptureEmpty && (
                  <span className="error-message">
                    A captação de água é obrigatória.
                  </span>
                )}
              </div>

              <button
                type="button"
                onClick={handleSaveExploration}
                disabled={!isExplorationFormValid}
                className="btn-save-exploration"
              >
                Salvar Exploração
                <i className="fa-solid fa-floppy-disk"></i>
              </button>
            </form>
          </div>
        )}

        {!showExplorationCard &&
          explorations &&
          explorations.map((exploration) => (
            <div className="edit-container" key={exploration.id}>
              <h3>Exploração Salva</h3>
              <div className="exploration-list">
                <h4 className="exploration-title">
                  {exploration.title ||
                    exploration.nome ||
                    'Título da Exploração'}
                </h4>
                <button
                  onClick={() => handleEditExploration(exploration)}
                  className="btn-edit-exploration"
                >
                  Editar
                  <i className="fa-solid fa-pen-to-square"></i>
                </button>
                <button
                  onClick={() => handleAddCulture(exploration)}
                  className="btn-add-culture"
                >
                  Adicionar Cultura
                  <i className="fa-solid fa-plus"></i>
                </button>
              </div>

              {/* Render cultures for the current exploration */}
              {exploration.culturas && exploration.culturas.length > 0 && (
                <div className="cultures-list">
                  <h3>Culturas Salvas</h3>
                  <div className="cultures-list">
                    <ul>
                      {exploration.culturas &&
                        exploration.culturas.map((culture) => (
                          <>
                            <li key={culture.id}>
                              {culture.nome} - {culture.variedade}
                              <button
                                onClick={() =>
                                  handleEditCulture(exploration, culture)
                                }
                                className="btn-edit-culture"
                              >
                                Editar
                                <i className="fa-solid fa-pen-to-square"></i>
                              </button>
                            </li>
                            {renderCertificatesByCulturaID(culture.id)}
                          </>
                        ))}
                    </ul>
                  </div>
                </div>
              )}
              {/* --------------- Secção da Cultura --------------- */}

              {showCultureCard &&
                showExplorationCultureCard &&
                showExplorationCultureCard.id === exploration.id && (
                  <section className="culture-container">
                    <div className="card">
                      <h3>
                        {isEditingCulture ? 'Editar Cultura' : 'Nova Cultura'}
                      </h3>
                      <h4>
                        {currentCulture.cultureTitle !== '' ||
                          'Título da Cultura'}{' '}
                        {currentCulture.cultureSpecie &&
                          `- ${currentCulture.cultureSpecie}`}
                      </h4>
                      <form
                        className="profile-form"
                        encType="multipart/form-data"
                      >
                        <div className="form-group">
                          <label htmlFor="culture-title">
                            Identificação da Cultura:
                          </label>
                          <input
                            id="culture-title"
                            name="cultureTitle"
                            type="text"
                            placeholder="Tipo de produto cultivado"
                            value={currentCulture.cultureTitle}
                            onChange={handleCultureChange}
                            required
                            className={isCultureTitleEmpty ? 'input-error' : ''}
                          />
                          {isCultureTitleEmpty && (
                            <span className="error-message">
                              O nome da cultura é obrigatório.
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="culture-specie">Variedade:</label>
                          <input
                            id="culture-specie"
                            name="cultureSpecie"
                            type="text"
                            placeholder="Variedade da cultura"
                            value={currentCulture.cultureSpecie}
                            onChange={handleCultureChange}
                            required
                            className={
                              isCultureSpecieEmpty ? 'input-error' : ''
                            }
                          />
                          {isCultureSpecieEmpty && (
                            <span className="error-message">
                              A variedade da cultura é obrigatória.
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="culture-indicator">
                            Tipo de Cultivo:
                          </label>
                          <select
                            id="culture-indicator"
                            name="cultureIndicator"
                            value={currentCulture.cultureIndicator}
                            onChange={handleCultureChange}
                            required
                          >
                            <option value="">Opções</option>
                            <option value="ESTUFA">Cultura de Estufa</option>
                            <option value="EXTERIOR">Cultura Exterior</option>
                          </select>
                        </div>

                        <div className="form-group">
                          <label htmlFor="culture-type">
                            Tipo de Produção:
                          </label>
                          <select
                            id="culture-type"
                            name="cultureType"
                            value={currentCulture.cultureType}
                            onChange={handleCultureChange}
                            required
                            className={
                              isCultureTypeEmpty || isProducaoTypeInvalid
                                ? 'input-error'
                                : ''
                            }
                          >
                            <option value="">Opções</option>
                            {tipoProducaoChoices &&
                              tipoProducaoChoices.map((choice) => (
                                <option key={choice[0]} value={choice[0]}>
                                  {choice[1]}
                                </option>
                              ))}
                          </select>
                          {isCultureTypeEmpty && (
                            <span className="error-message">
                              O tipo de produção é obrigatório.
                            </span>
                          )}
                          {isProducaoTypeInvalid && (
                            <span className="error-message">
                              O tipo de produção selecionado não é válido.
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="culture-cultura-type">
                            Tipo de Cultura:
                          </label>
                          <select
                            id="culture-cultura-type"
                            name="cultureCulturaType"
                            value={currentCulture.cultureCulturaType}
                            onChange={handleCultureChange}
                            required
                            className={
                              isCultureTypeEmpty || isCultureTypeInvalid
                                ? 'input-error'
                                : ''
                            }
                          >
                            <option value="">Opções</option>
                            {tipoCulturaChoices &&
                              tipoCulturaChoices.map((choice) => (
                                <option key={choice[0]} value={choice[0]}>
                                  {choice[1]}
                                </option>
                              ))}
                          </select>
                          {isCultureTypeEmpty && (
                            <span className="error-message">
                              O tipo de cultura é obrigatório.
                            </span>
                          )}
                          {isCultureTypeInvalid && (
                            <span className="error-message">
                              O tipo de cultura selecionado não é válido.
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="culture-area">
                            Área por Cultura (hectares):
                          </label>
                          <input
                            id="culture-area"
                            name="cultureArea"
                            type="number"
                            min="0"
                            value={currentCulture.cultureArea}
                            onChange={handleCultureChange}
                            placeholder="Digite a área por cultura em hectares"
                            required
                            className={isCultureAreaEmpty ? 'input-error' : ''}
                          />
                          {isCultureAreaEmpty && (
                            <span className="error-message">
                              A área por cultura deve ser maior que zero.
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="culture-compass">Compasso:</label>
                          <input
                            id="culture-compass"
                            name="cultureCompass"
                            type="text"
                            placeholder="Ex: 70x20 cm's"
                            value={currentCulture.cultureCompass}
                            onChange={handleCultureChange}
                            required
                            className={
                              isCultureCompassEmpty ? 'input-error' : ''
                            }
                          />
                          {isCultureCompassEmpty && (
                            <span className="error-message">
                              O compasso é obrigatório.
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="culture-watering-type">
                            Tipo de Sistema de Rega:
                          </label>
                          <select
                            id="culture-watering-type"
                            name="cultureWateringType"
                            value={currentCulture.cultureWateringType}
                            onChange={handleCultureChange}
                            required
                            className={
                              isCultureWateringTypeEmpty ||
                              isSistemaRegaTypeInvalid
                                ? 'input-error'
                                : ''
                            }
                          >
                            <option value="">Opções</option>
                            {tipoSistemaRegaChoices &&
                              tipoSistemaRegaChoices.map((choice) => (
                                <option key={choice[0]} value={choice[0]}>
                                  {choice[1]}
                                </option>
                              ))}
                          </select>
                          {isCultureWateringTypeEmpty && (
                            <span className="error-message">
                              O tipo de sistema de rega é obrigatório.
                            </span>
                          )}
                          {isSistemaRegaTypeInvalid && (
                            <span className="error-message">
                              O tipo de sistema de rega selecionado não é
                              válido.
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="culture-watering-number">
                            Número de Sectores de Rega:
                          </label>
                          <input
                            id="culture-watering-number"
                            name="cultureWateringNumber"
                            type="number"
                            min="0"
                            value={currentCulture.cultureWateringNumber}
                            onChange={handleCultureChange}
                            placeholder="Totalidade dos sectores de rega"
                            required
                            className={
                              isCultureWateringNumberEmpty ? 'input-error' : ''
                            }
                          />
                          {isCultureWateringNumberEmpty && (
                            <span className="error-message">
                              O número de sectores de rega deve ser maior que
                              zero.
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="cert-pdf" className="cert-culture">
                            Mapa dos Sectores de Rega:
                          </label>
                          <label
                            htmlFor="upload-pdf-mapa-sectores"
                            className="btn-upload"
                          >
                            {mapaSectoresFileName !==
                            'Nenhum ficheiro carregado'
                              ? 'Atualizar PDF'
                              : 'Carregar PDF'}
                            <i className="fa-solid fa-upload"></i>
                          </label>
                          <input
                            type="file"
                            accept="application/pdf"
                            onChange={handleMapaSectoresFileChange}
                            id="upload-pdf-mapa-sectores"
                          />
                          {mapaSectoresFileName !==
                          'Nenhum ficheiro carregado' ? (
                            <button
                              type="button"
                              onClick={() =>
                                handleOpenWaterMapPdf(currentCulture.id)
                              }
                              className="file-name uploaded-file pdf-link"
                              title="Clique para abrir o PDF"
                              disabled={!currentCulture.id}
                            >
                              <i className="fa-solid fa-file-pdf"></i>{' '}
                              {mapaSectoresFileName}
                            </button>
                          ) : (
                            <span className="file-name">
                              {mapaSectoresFileName}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="culture-soil-type">
                            Classe Textural do Solo:
                          </label>
                          <select
                            id="culture-soil-type"
                            name="cultureSoilType"
                            value={currentCulture.cultureSoilType}
                            onChange={handleCultureChange}
                            required
                            className={
                              isCultureSoilTypeEmpty ? 'input-error' : ''
                            }
                          >
                            <option value="">Opções</option>
                            {classeTexturalChoices &&
                              classeTexturalChoices.map((choice) => (
                                <option key={choice[0]} value={choice[0]}>
                                  {choice[1]}
                                </option>
                              ))}
                          </select>
                          {isCultureSoilTypeEmpty && (
                            <span className="error-message">
                              A classe textural do solo é obrigatória.
                            </span>
                          )}
                          {isClasseTexturalInvalid && (
                            <span className="error-message">
                              A classe textural do solo selecionada não é
                              válida.
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="culture-production">
                            Produção por Cultura (t):
                          </label>
                          <input
                            id="culture-production"
                            name="cultureProduction"
                            type="number"
                            min="0"
                            value={currentCulture.cultureProduction}
                            onChange={handleCultureChange}
                            placeholder="Produção por cultura em toneladas"
                            required
                            className={
                              isCultureProductionEmpty ? 'input-error' : ''
                            }
                          />
                          {isCultureProductionEmpty && (
                            <span className="error-message">
                              A produção por cultura deve ser maior que zero.
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="culture-production-sector">
                            Produção por Parcela/Sector (t):
                          </label>
                          <input
                            id="culture-production-sector"
                            name="cultureProductionSector"
                            type="number"
                            min="0"
                            value={currentCulture.cultureProductionSector}
                            onChange={handleCultureChange}
                            placeholder="Produção por parcela/sector em toneladas"
                            required
                            className={
                              isCultureProductionSectorEmpty
                                ? 'input-error'
                                : ''
                            }
                          />
                          {isCultureProductionSectorEmpty && (
                            <span className="error-message">
                              A produção por parcela/sector deve ser maior que
                              zero.
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="culture-production-hectare">
                            Produção por Hectare (kg):
                          </label>
                          <input
                            id="culture-production-hectare"
                            name="cultureProductionHectare"
                            type="number"
                            min="0"
                            value={currentCulture.cultureProductionHectare}
                            onChange={handleCultureChange}
                            placeholder="Produção por hectare em quilogramas"
                            required
                            className={
                              isCultureProductionHectareEmpty
                                ? 'input-error'
                                : ''
                            }
                          />
                          {isCultureProductionHectareEmpty && (
                            <span className="error-message">
                              A produção por hectare deve ser maior que zero.
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="culture-year-type">
                            Características do Ano:
                          </label>
                          <select
                            id="culture-year-type"
                            name="cultureYearType"
                            value={currentCulture.cultureYearType}
                            onChange={handleCultureChange}
                            required
                            className={
                              isCultureYearTypeEmpty ? 'input-error' : ''
                            }
                          >
                            <option value="">Opções</option>
                            {caracteristicasAnoChoices &&
                              caracteristicasAnoChoices.map((choice) => (
                                <option key={choice[0]} value={choice[0]}>
                                  {choice[1]}
                                </option>
                              ))}
                          </select>
                          {isCultureYearTypeEmpty && (
                            <span className="error-message">
                              As características do ano são obrigatórias.
                            </span>
                          )}
                          {isCaracteristicasAnoInvalid && (
                            <span className="error-message">
                              As características do ano selecionadas não são
                              válidas.
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="cert-pdf" className="cert-culture">
                            Outros Documentos (PDF):
                          </label>
                          <label
                            htmlFor="upload-pdf-other-docs"
                            className="btn-upload"
                          >
                            {otherDocsFileName !== 'Nenhum ficheiro carregado'
                              ? 'Atualizar PDF'
                              : 'Carregar PDF'}
                            <i className="fa-solid fa-upload"></i>
                          </label>
                          <input
                            type="file"
                            accept="application/pdf"
                            onChange={handleOtherDocsFileChange}
                            id="upload-pdf-other-docs"
                            // required
                          />
                          {otherDocsFileName !== 'Nenhum ficheiro carregado' ? (
                            <button
                              type="button"
                              onClick={() =>
                                handleOpenOtherDocsPdf(currentCulture.id)
                              }
                              className="file-name uploaded-file pdf-link"
                              title="Clique para abrir o PDF"
                              disabled={!currentCulture.id}
                            >
                              <i className="fa-solid fa-file-pdf"></i>{' '}
                              {otherDocsFileName}
                            </button>
                          ) : (
                            <span className="file-name">
                              {otherDocsFileName}
                            </span>
                          )}
                        </div>

                        <button
                          type="button"
                          className="btn-save-edit"
                          onClick={handleSaveCulture}
                          disabled={!isSaveButtonEnabled || isRefreshing}
                          style={{
                            backgroundColor:
                              isSaveButtonEnabled && !isRefreshing
                                ? '#64A555'
                                : '#CCC',
                            cursor:
                              isSaveButtonEnabled && !isRefreshing
                                ? 'pointer'
                                : 'not-allowed',
                          }}
                        >
                          {isRefreshing ? 'A guardar...' : 'Salvar Cultura'}
                          <i
                            className={
                              isRefreshing
                                ? 'fa-solid fa-spinner fa-spin'
                                : 'fa-solid fa-floppy-disk'
                            }
                          ></i>
                        </button>
                      </form>
                    </div>
                  </section>
                )}
            </div>
          ))}

        {/* -- Este botão deve estar sempre no fim da página. -- */}

        {!showExplorationCard && (
          <button
            className="btn-add-exploration"
            onClick={handleAddExploration}
          >
            Adicionar Exploração
            <i className="fa-solid fa-plus"></i>
          </button>
        )}
      </section>
    </section>
  );
};

export default Profile;
